import axios from 'axios';
import validateTime from "./validate/validateCallRequestConvenientTime";

/**
 * Форма заказать звонок.
 * @returns {Promise<void>}
 * @constructor
 */
export default async function CallRequestModal() {
  // Показать удобное время для звонка
  const btnForTime = document.querySelector('.btn_for_callTime');
  const formForTime = document.querySelector('.form_for_callTime');

  if (formForTime) {
    btnForTime.onclick = () => {
      formForTime.classList.add('active');
      btnForTime.style.marginBottom = '10px';
    };
  }

  // Валидация формы
  const isRequired = (value) => value !== '';

  const checkName = (activeForm) => {
    const nameInput = activeForm.querySelector('#fio');
    const formItem = nameInput.closest('.form-item');
    if (!isRequired(nameInput.value.trim())) {
      formItem.classList.add('err-item');
      return false;
    }
    formItem.classList.remove('err-item');
    return true;
  };

  const checkPhoneValid = (activeForm) => {
    const phoneItem = activeForm.querySelector('#phone');
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    const isValidRes = re.test(phoneItem.value.trim().replace(/\s/g, ''));
    if (!isValidRes) {
      phoneItem.closest('.form-item').classList.add('err-item');
      return false;
    }
    phoneItem.closest('.form-item').classList.remove('err-item');

    return true;
  };

  const checkPersonal = (activeForm) => {
    const personalCheck = activeForm.querySelector('[name="agreedBox"]');
    if (!personalCheck.checked) {
      personalCheck.closest('.form-checkbox').classList.add('err-box');
      return false;
    }
    personalCheck.closest('.form-checkbox').classList.remove('err-box');

    return true;
  };

  const checkTime = (activeForm) => {
    return validateTime(activeForm);
  };

  // Проверка валидности формы
  function isValid(activeForm) {
    const formName = checkName(activeForm);
    const personalValid = checkPersonal(activeForm);
    const phoneValid = checkPhoneValid(activeForm);
    const timeValid = checkTime(activeForm);

    return formName && personalValid && phoneValid && timeValid;
  }

  // Нажатие на кнопке отправить
  const formSendBtns = document.querySelectorAll('.order_a_callback .form-send');
  if (formSendBtns) {
    // eslint-disable-next-line no-restricted-syntax
    for (const btn of formSendBtns) {
      const activeForm = btn.closest('form');
      await sendRequests(btn, activeForm);
    }
  }

  // для яндекс метрики необходимо событие взаимодействия с формой
  document.querySelectorAll('.order_a_callback').forEach((form) => {
    form.addEventListener('change', () => {
      // отправляем событие в GTM
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'GoalEvent',
          eventCategoryUA: 'callback',
          eventActionUA: 'inputForm',
          eventGoalYM: 'callback_inputForm',
          eventGA4: 'callback_inputForm',
        });
      }
    }, { once: true });
  });

  /**
   * Отправка данных с формы записи на приём.
   * @returns {Promise<void>}
   */
  async function sendRequests(button, form) {
    /**
     * Отправка формы записи на приём
     * @param {Event} event
     */
    async function sendFn(event) {
      event.preventDefault();
      const token = document.querySelector('meta[name="csrf-token"]').content;

      let captcha = null;

      if (window.grecaptcha) {
        // grecaptcha.ready(function() {
        captcha = await window.grecaptcha.execute('6LcAVG4qAAAAAEDz96PRBLGGpefHeT2_LXlmiHMz', { action: 'submit' });
        // });
      }

      if (captcha && isValid(form)) {
        try {
          button.disabled = true;
          button.innerText = 'Отправка';
          const isConvTime = form.querySelector('.form_for_callTime.active');

          let metrikaClientId = '';
          let gaClientId = '';

          try {
            if (window.yaCounter50475) {
              metrikaClientId = window.yaCounter50475.getClientID();
            }
          } catch (e) {
            //
          }

          try {
            if (window.gaGlobal && window.gaGlobal.vid) {
              gaClientId = window.gaGlobal.vid;
            }
          } catch (e) {
            //
          }

          const q = await axios.post('/request_callback/', {
            _token: token,
            page_url: window.location.href,
            page_name: document.querySelector('title').innerText.trim(),
            captcha,
            appoint_privacy: form.querySelector('[name="agreedBox"]').checked ? 1 : 0,
            name: form.querySelector('input[name="fio"]').value.trim(),
            phone: form.querySelector('input[name="phone"]').value.trim(),
            conv_time: isConvTime ? form.querySelector('input[name="conv_time"]').value.trim() : '',
            metrikaClientId,
            gaClientId,
          });

          const { status, html } = q.data;
          if (status) {
            button.innerText = 'Отправлено';
            form.innerHTML = html;

            // отправляем событие в GTM
            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'GoalEvent',
                eventCategoryUA: 'callback',
                eventActionUA: 'sendForm',
                eventGoalYM: 'callback_sendForm',
                eventGA4: 'callback_sendForm',
              });
            }
          }
        } catch (err) {
          const { data } = err.response;
          //
          button.disabled = false;
          button.innerText = 'Ошибка. Попробуйте еще раз';
          writeMessage(form, data.message);
        }
      }
    }

    button.addEventListener('click', sendFn);
  }

  function writeMessage(form, message) {
    const messageElement = form.querySelector('.calltouch-message');
    messageElement.innerHTML = message;
    messageElement.style.display = 'block';
  }

  // Функция небольшой задержки.
  // Срабатывает, когда происходит ввод данных в форме
  const debounce = (fn, delay = 100) => {
    let timeoutId;
    return (...args) => {
      // cancel the previous timer
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // setup a new timer
      timeoutId = setTimeout(() => {
        fn.apply(null, args);
      }, delay);
    };
  };

  const tabsForms = document.querySelectorAll('.order_a_callback input');
  tabsForms.forEach((tabsForm) => {
    // Проверка на правильность заполнения полей при потере фокуса
    tabsForm.addEventListener('blur', debounce((e) => {
      const actForm = e.target.closest('.order_a_callback');
      switch (e.target.id) {
        case 'fio':
          checkName(actForm);
          break;
        case 'phone':
          checkPhoneValid(actForm);
          break;
        case 'time':
          checkTime(actForm);
          break;
        default:
          break;
      }
    }));

    // Снятие выделения полей при вводе
    tabsForm.addEventListener('focus', debounce(() => {
      const parentItem = tabsForm.closest('.form-item');
      parentItem.classList.remove('err-item');
      parentItem.classList.remove('err-item-call-back');
    }));
  });

  // Навешивание маски на поля времени
  const callTime = document.querySelectorAll('.time-back-call');
  if (callTime) {
    callTime.forEach((call) => {
      const maskOptions = {
        mask: '00:00',
        lazy: false,
      };
      const timeMask = IMask(call, maskOptions);
    });
  }
}
